import { render } from "./CookiePage.vue?vue&type=template&id=e737b7cc&scoped=true"
import script from "./CookiePage.vue?vue&type=script&lang=js"
export * from "./CookiePage.vue?vue&type=script&lang=js"

import "./CookiePage.vue?vue&type=style&index=0&id=e737b7cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e737b7cc"]])

export default __exports__